import ActionButton from '../../../components/actionButton/ActionButton';
import TextInput from '../../../components/textInput/TextInput';
import * as style from './style.css';
import { AccountService } from '../../../services/accountService/AccountService';
import { Action } from '../../../framework/framework/components/Types';
import classes from '../../../framework/framework/tools/classes';
import React = require('react');

interface IProps {
accountService: AccountService;
onSuccess: Action;
}
interface IState {
    email: string;
    password: string;
    loginError: boolean;
    inProgress: boolean;
}

export default class LoginForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            email: '',
            password: '',
            loginError: false,
            inProgress: false
        };
    }

    render() {
        return (
            <form>
                <div className={style.formContainer}>
                    <TextInput
                        key={4}
                        value={this.state.email}
                        onChange={(s: string) => this.setState({ email: s })}
                        onKeyDown={() => { }}
                        placeholder="adres email (wymagane)" />
                    <TextInput
                        key={6}
                        value={this.state.password}
                        onChange={(s: string) => this.setState({ password: s })}
                        onKeyDown={() => { }}
                        placeholder={'hasło (wymagane)'}
                        autoComplete={'current-password'}
                        type='password' />
                    <div className={style.buttonWrapper} key={'button'}>
                        <ActionButton label={'Zaloguj'}
                            onClick={() => this.onLoginClick()}
                            disabled={this.state.inProgress} />
                    </div>
                    {this.state.loginError && <div key={'error'} className={classes(style.error, style.message)}>
                        Nieprawidłowy login lub hasło
                    </div>}
                </div>
            </form>

        );
    }

    onLoginClick(): void {
        this.props.accountService.login(this.state.email,
            this.state.password,
            () => this.props.onSuccess(),
            () => {
                this.setState({ loginError: true });
            }
        );
    }
}
